/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonUserInfo,
    JsonUserInfoFromJSON,
    JsonUserInfoFromJSONTyped,
    JsonUserInfoToJSON,
} from './JsonUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonUserInfo
 */
export interface ApiResultOfListOfJsonUserInfo {
    /**
     * 
     * @type {Array<JsonUserInfo>}
     * @memberof ApiResultOfListOfJsonUserInfo
     */
    data?: Array<JsonUserInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonUserInfo
     */
    result?: ApiResultOfListOfJsonUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonUserInfoFromJSON(json: any): ApiResultOfListOfJsonUserInfo {
    return ApiResultOfListOfJsonUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonUserInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonUserInfoToJSON(value?: ApiResultOfListOfJsonUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonUserInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

